// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"295":"e755d766","5412":"271ebc11","7046":"8b1d2ec7","8044":"4d8c1e25","9287":"85c61213"}[chunkId] + ".chunk.css";
};